module.exports = __webpack_public_path__ + "static/media/promo2.7106bf50.jpg";